// src/utils/permissionUtils.js
import { useMemo } from "react";
import jwtDecode from "jwt-decode";

export const useSavedPermissions = () => {
  return useMemo(() => {
    return JSON.parse(localStorage.getItem("rbacPermissions")) || [];
  }, []);
};

// If you need a non-hook version
export const getSavedPermissions = () => {
  return JSON.parse(localStorage.getItem("rbacPermissions")) || [];
};

/**
 * Check if the current user is a client (business owner) who should bypass permission checks
 * Clients have ONLY clientId in JWT token (no userId)
 * Users created by clients have BOTH userId AND clientId
 * @returns {boolean} True if user is a client, false if user is a created user
 */
export const isClientUser = () => {
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");

  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);
    // Client accounts have ONLY clientId (no userId)
    // Created users have BOTH userId and clientId
    // Only bypass permissions if user is pure client (has clientId but NO userId)
    return !!decoded.clientId && !decoded.userId;
  } catch (error) {
    console.error("Error decoding JWT token:", error);
    return false;
  }
};

/**
 * Check if user has permission, with client bypass logic
 * @param {string} requiredPermission - The permission to check
 * @returns {boolean} True if user has permission or is a client
 */
export const hasPermission = (requiredPermission) => {
  // If user is a client (business owner), bypass all permission checks
  if (isClientUser()) {
    return true;
  }

  // For users created by clients, check permissions
  const savedPermissions = getSavedPermissions();
  return savedPermissions.includes(requiredPermission);
};
